import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AgmCoreModule } from '@agm/core';
import { CalendarModule } from 'angular-calendar';

import { routing } from './app.routing';
import { AppSettings } from './app.settings';

import { AppComponent } from './app.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';

import { HttpModule } from '@angular/http'; /** ANTHONY JSON ADDED*/

//import { HeaderLoginComponent } from './theme/components/headerlogin/headerlogin.component';

@NgModule({
  declarations: [
    //HeaderLoginComponent,
    AppComponent,
    NotFoundComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule, /** ANTHONY JSON ADDED */
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDe_oVpi9eRSN99G4o6TwVjJbFBNr58NxE' //ANTHONY API key for google maps
    }),
    ////ChartModule, /* ANTHONY added for HIGHCHARTS */
    CalendarModule.forRoot(),
    routing
  ],
  providers: [ AppSettings ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/angular/glow/src/app/app.module.ts